// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ocMainControl {
  position: absolute;
  z-index: 1000;
}

.ocContent .mat-tab-label-active {
  color: #97bf0d !important;
  font-weight: bold;
}

.tabGroup {
  padding-top: 30px;
}

::ng-deep .tabGroup .mat-tab-body-wrapper {
  height: 100%
}


.ocContent .mat-ink-bar {
  background: yellow;
  height: 10px;
}

::ng-deep .tabs .mat-tab-header {
  left: 42px;
  right: 0px;
  position: absolute;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/objectcreator/objectcreator.maincontrol.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;AACF;;;AAGA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,UAAU;EACV,kBAAkB;AACpB","sourcesContent":[".ocMainControl {\n  position: absolute;\n  z-index: 1000;\n}\n\n.ocContent .mat-tab-label-active {\n  color: #97bf0d !important;\n  font-weight: bold;\n}\n\n.tabGroup {\n  padding-top: 30px;\n}\n\n::ng-deep .tabGroup .mat-tab-body-wrapper {\n  height: 100%\n}\n\n\n.ocContent .mat-ink-bar {\n  background: yellow;\n  height: 10px;\n}\n\n::ng-deep .tabs .mat-tab-header {\n  left: 42px;\n  right: 0px;\n  position: absolute;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
